const createRowKey = (row) => {
  if (row.rowType === 'bonus') {
    return `bonus:${row.orderBonusId ?? `${row.invoiceId}:${row.productId}:${row.code}`}`;
  }
  if (row.detailId != null) return `detail:${row.detailId}`;
  if (row.code) return `code:${row.code}:${row.invoiceId}`;
  return `row:${row.invoiceId}:${row.productId}:${row.description}`;
};

export const buildUnifiedPaymentRows = (
  selectedDetails = [],
  selectedBonusDetails = []
) => {
  const map = {};
  selectedDetails.forEach((row) => {
    const invoiceId = Number(row.invoiceId);
    if (!invoiceId) return;
    if (!map[invoiceId]) map[invoiceId] = [];
    map[invoiceId].push({ ...row, rowKey: createRowKey(row) });
  });

  const seenBonusIds = new Set();
  selectedBonusDetails.forEach((bonus) => {
    const invoiceId = Number(bonus.invoiceId);
    if (!invoiceId) return;
    const dedupeKey = bonus.orderBonusId != null
      ? `${invoiceId}:${bonus.orderBonusId}`
      : `${invoiceId}:${bonus.productId || bonus.code}:${bonus.description}`;
    if (seenBonusIds.has(dedupeKey)) return;
    seenBonusIds.add(dedupeKey);
    if (!map[invoiceId]) map[invoiceId] = [];
    const row = {
      ...bonus,
      rowType: 'bonus',
      rowKey: createRowKey({ ...bonus, rowType: 'bonus' }),
      prformat: bonus.format,
      quantity: Number(bonus.promised || 0),
      quantityRe: Number(bonus.received || 0),
      difference: Number(bonus.pending || 0),
      price: null,
      orderPrice: null,
      subtotal: null,
    };
    const baseIndex = map[invoiceId].findIndex(
      (detail) => Number(detail.productId || 0) === Number(bonus.baseProductId || 0)
    );
    if (baseIndex >= 0) {
      let insertAt = baseIndex + 1;
      while (
        insertAt < map[invoiceId].length
        && map[invoiceId][insertAt]?.rowType === 'bonus'
        && Number(map[invoiceId][insertAt]?.baseProductId || 0) === Number(bonus.baseProductId || 0)
      ) insertAt += 1;
      map[invoiceId].splice(insertAt, 0, row);
    } else {
      map[invoiceId].push(row);
    }
  });
  return map;
};
